import DiarySvg from '../icons/DiarySvg';

export default ({ values, setValues }) => {
    const handleChange = (e) => {
        const { name, checked } = e.target;

        setValues((prev) => ({
            ...prev,
            [name]: checked
        }));
    };

    return (
        <div className="modal-checkbox-wrapper">
            <h4>Hämta data från:</h4>

            <div className="modal-checkbox-inner">
                <label>
                    <DiarySvg name="circle" color={['#FFDB4C', '#A77E52']} />

                    <input type="checkbox" id="db1" name="db1" checked={values.db1} onChange={handleChange} />

                    <span>Svenska livsmedelverkets databas</span>
                </label>

                <label>
                    <DiarySvg name="circle" color={['#AF7DEF', '#A77E52']} />

                    <input type="checkbox" id="db2" name="db2" checked={values.db2} onChange={handleChange} />

                    <span>Sveriges livsmedelföretags databas</span>
                </label>
            </div>
        </div>
    );
};
